import { configureStore, combineReducers, AnyAction, Reducer } from '@reduxjs/toolkit';
//import logger from 'redux-logger';
import localforage from 'localforage';
import {
  persistStore,
  persistReducer,
} from 'redux-persist';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';

import globalOkDialogReducer from '../features/globalOkDialogSlice';
import globalYesNoDialogReducer from '../features/globalYesNoDialogSlice';
import globalYesNoCancelDialogReducer from '../features/globalYesNoCancelDialogSlice';
import loginReducer from '../features/loginSlice';
import jobMenuReducer from '../features/jobMenuSlice';
//import oceanImportNewMblReducer from '../features/oceanImportNewMblSlice';
import operationReducer from '../features/operationSlice';
import screenStackReducer from '../features/screenStackSlice';
import storageReducer from '../features/storageSlice';
import activeDutyTrackingSliceReducer from '../features/activeDutyTrackingSlice';
import lastSavedJobReducer from '../features/lastSavedJobSlice';
import listScreenSettingsReducer from '../features/listScreenSettingsSlice';
import globalInputDialogReducer from '../features/globalInputDialogSlice';

export const EnablePersistence = false;

const combinedReducer = combineReducers({
  globalOkDialog: globalOkDialogReducer,
  globalYesNoDialog: globalYesNoDialogReducer,
  globalYesNoCancelDialog: globalYesNoCancelDialogReducer,
  user: loginReducer,
  jobMenu: jobMenuReducer,
  //oceanImportNewMbl: oceanImportNewMblReducer,
  operation: operationReducer,
  screenStack: screenStackReducer,
  storage: storageReducer,
  activeDutyTracking: activeDutyTrackingSliceReducer,
  lastSavedJob: lastSavedJobReducer,
  listScreenSettings: listScreenSettingsReducer,

  //<pt220928: portal>
  globalInputDialog: globalInputDialogReducer,
});

const rootReducer:Reducer = (state:RootState, action:AnyAction) => {
  if (action.type === 'login/reset') {
    // Reset everything but the user
    state = {
      user: state.user,
    } as RootState;
  }

  return combinedReducer(state, action);
}

const persistConfig = {
  key: 'ifmsv36',
  storage: localforage,
  blacklist: [
    'initialized',
    'user',
    'operation',
    'jobMenu',
    'screenStack',
    'oceanImportNewMbl',
    'commonNewCompany',
    'oceanImportNewBill',
    'codesAccountingNewCurrency',
    'oceanImportNewInvoice',
    'oceanImportNewCrdb',
    "globalYesNoDialog",
    "globalYesNoCancelDialog",
    "globalOkDialog",
    'storage',
    'oceanImportNewHbl',
    'codesOceanNewContainerType',
    'codesCompanyNewCompanyUser',
    'systemSettingsRetry',
    'activeDutyTracking',
    'lastSavedJob',
    'listScreenSettings',
  ],
  // stateReconciler: hardSet, // TODO -research why it is not working with typescript. Resulting state is null
  version: 36,
};

const allReducers = EnablePersistence ? persistReducer(persistConfig, rootReducer) : rootReducer;

export const store = configureStore({
  reducer: allReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
    //.prepend(logger),
});

export type RootState = ReturnType<typeof combinedReducer>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
